<div class="fonts text-style">
  <div class="reflection-popup-overlay" *ngIf="showReflectionPopup">
    <div class="reflection-popup">
      <div class="reflection-popup-header">
        <h3>Attention</h3>
      </div>
      <div class="reflection-popup-body">
        <p>{{ msg }}</p>
      </div>
      <div class="reflection-popup-footer">
        <button class="btn btn-secondary btn-danger" (click)="goToReflectionNow()">
          Continue with Reflection
        </button>
      </div>
    </div>
  </div>
  <div class="alert alert-success" *ngIf="kpiSuccess">
    Initiative has been saved successfully.
  </div>
  <div class="alert alert-success" *ngIf="hoshinSubmit">
    Annual Plan has been submitted successfully.
  </div>
  <div class="alert alert-success" *ngIf="hoshinApproved">
    Initiative has been approved successfully.
  </div>
  <div class="alert alert-success" *ngIf="hoshinRejected">
    Initiative has been declined.
  </div>
  <div class="alert alert-success" *ngIf="overallHoshinApproved">
    Annual Plan has been approved successfully.
  </div>
  <div class="alert alert-success" *ngIf="overallHoshinRejected">
    Annual Plan has been declined.
  </div>
  <div class="alert alert-success" *ngIf="kpiReviewSaved">
    KPI review has been saved successfully.
  </div>
  <div class="alert alert-danger" *ngIf="kpiExist">This KPI has already been added to the initiative.</div>
  <div class="col-md-12 container-fluid text-style" style="padding: 2% 5%">
    <div class="col-md-12 pl-0 pr-0 col-xs-12 col-sm-12 mb-4 heading1">
      <span class="span-create-edit-hoshin1 color">ANNUAL PLAN</span>
      <span class="pt-1" *ngIf="this.adminId == '1'" style="font-size: 13px"><a
          href="assets/userguides/ERG_UG_AnnualPlan_SuperAdmin.pdf" download class="pl-3 download-link">User
          Guide</a></span>
      <span class="pt-1" *ngIf="
          this.adminId == '2' ||
          this.adminId == '3' ||
          this.adminId == '4' ||
          this.isbpgLeadAdmin ||
          this.isbpgAdmin ||
          this.isNaacAdmin
        " style="font-size: 13px"><a href="assets/userguides/ERG_UG_AnnualPlan_ERGAdmin.pdf" download
          class="pl-3 download-link">User Guide</a></span>
      <span style="float: right"><button type="button" class="btn btn-danger btn-style" style="font-size: xx-small"
          routerLink="../annual-plan-home">
          BACK TO ANNUAL PLAN
        </button></span>
    </div>
    <div class="font-weight-bold" [ngStyle]="{
        marginTop: adminId == '1' && selectedChapter ? '15px' : '0%'
      }">
      <div *ngIf="adminId != '1' && adminId != '4' && !isNaacAdmin">
        <span class="text-style color">Annual Plan : </span>
        <span style="font-weight: normal">
          <span class="text-style ml-1">{{ siteName }} - {{ bpgName }}
            <span style="font-weight: 700"> &nbsp; > &nbsp; </span>
            <span class="ml-1 mr-1 color" style="text-decoration: underline; cursor: pointer;" title="Navigate to Initiatives"><a
                (click)="goToPlan(fiscalYear)">FY {{ fiscalYear }}</a></span>
            <span *ngIf="isAddNewInitiative">
              <span style="font-weight: 700"> &nbsp; > &nbsp; </span>
              {{ initiativeName }}</span>
          </span>
        </span>
        <span style="float: right" *ngIf="
            (adminId == '1' && selectedChapter) ||
            adminId == '2' ||
            adminId == '3' ||
            isbpgAdmin ||
            isbpgLeadAdmin
          ">
          Status :
          <span class="color">{{overallStatus === "REJECTED" ? "NOT APPROVED": overallStatus}}</span>
        </span>
      </div>
      <div *ngIf="adminId == '1' && selectedChapter" class="text-style mt-2">
        <span style="font-weight: normal">
          <span style="font-weight: normal; font-size: 10px">Showing for</span>
          <span class="color ml-1 mr-1">{{ siteName }}</span> {{ bpgName }}
          <span style="font-weight: 700">&nbsp; > &nbsp;</span>
          <span class="color ml-1" style="text-decoration: underline;cursor: pointer;" title="Navigate to Initiatives"><a
              (click)="goToPlan(fiscalYear)">FY {{ fiscalYear }}</a></span>
          <span class="ml-1" *ngIf="isAddNewInitiative">
            <span style="font-weight: 700">&nbsp; > &nbsp;</span>
            {{ initiativeName }}</span>
        </span>
        <span style="float: right" *ngIf="
            (adminId == '1' && selectedChapter) ||
            adminId == '2' ||
            adminId == '3'
          ">
          Status :
          <span class="color">{{overallStatus === "REJECTED" ? "NOT APPROVED": overallStatus}}</span>
        </span>
      </div>
    </div>
    <div *ngIf="(adminId == '4' || isNaacAdmin) && selectedChapter" class="text-style font-weight-bold mt-2" [ngStyle]="{
        marginTop: (adminId == '4' || isNaacAdmin) && selectedChapter ? '25px' : '0px'
      }">
      <span style="font-weight: normal">
        <span style="font-weight: normal; font-size: 10px">Showing for</span>
        <span class="color ml-1 mr-1">{{ siteName }}</span> {{ bpgName }}
        <span style="font-weight: 700"> &nbsp; > &nbsp; </span>
        <span class="color ml-1"> FY {{ fiscalYear }}</span>
      </span>
      <span style="float: right" *ngIf="
          overallStatus == 'APPROVED' ||
          overallStatus == 'REJECTED' ||
          overallStatus == 'DRAFT' ||
          overallStatus == 'NEW' ||
          overallStatus == 'SUBMITTED'
        ">
        Status : <span class="color">{{overallStatus === "REJECTED" ? "NOT APPROVED": overallStatus}}</span></span>
    </div>
    <div class="row" *ngIf="
        adminId == '3' ||
        adminId == '2' ||
        isbpgAdmin ||
        isbpgLeadAdmin ||
        (adminId == '1' && selectedChapter) ||
        ((adminId == '4' || isNaacAdmin) && selectedChapter)
      ">
      <div class="col-md-3 mt-4">
        <div *ngIf="selectedChapter">
          <ul class="nav flex-column nav-pills" role="tablist" *ngFor="let i of yearList">
            <li class="nav-item" *ngIf="i.enabled && i.type === 'reflection'">
              <a id="currentYearDisplay" class="nav-link cursor-pointer" [ngClass]="{
                  active: i.isActive == true && refIsActive == true
                }" data-toggle="pill" (click)="changeIsActive(i)">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>

            <li class="nav-item" *ngIf="
                !i.enabled &&
                i.type === 'plan' &&
                currentFiscalYear + 1 == i.year
              ">
              <a class="nav-link pointerDisable" data-toggle="pill">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>

            <li class="nav-item" *ngIf="
                i.enabled &&
                i.type === 'plan' &&
                currentFiscalYear + 1 == i.year
              ">
              <a id="currentYearDisplay" class="nav-link cursor-pointer" [ngClass]="{
                  active: i.isActive == true && refIsActive == true
                }" data-toggle="pill" (click)="changeIsActive(i)">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>
            <li class="nav-item" *ngIf="
                !i.enabled && i.type === 'plan' && currentFiscalYear >= i.year
              ">
              <a class="nav-link pointerDisable" data-toggle="pill">FY {{ i.year }} {{ "Initiatives" | titlecase }}</a>
            </li>

            <li class="nav-item" *ngIf="
                i.enabled && i.type === 'plan' && currentFiscalYear >= i.year
              ">
              <a id="currentYearDisplay" class="nav-link cursor-pointer" [ngClass]="{
                  active: i.isActive == true && refIsActive == true
                }" data-toggle="pill" (click)="changeIsActive(i)">FY {{ i.year }} {{ "Initiatives" | titlecase }}</a>
            </li>

            <li class="nav-item" *ngIf="!i.enabled && i.type === 'reflection'">
              <a class="nav-link pointerDisable" data-toggle="pill">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>
          </ul>
          <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
        </div>
      </div>

      <div class="col-md-9 mt-4 pr-0" *ngIf="displayType == 'reflection'">
        <div class="col-md-12 mt-5 pt-5 color text-center" *ngIf="refMsgActive">
        <h3>
          Reflection is currently unavailable.</h3><h5> This may be due to the Annual Plan being in new/draft status, not yet submitted, or not approved.<small class="nav-link" style="text-decoration: underline; font-style: italic;cursor: pointer;" (click)="goToPlan(fiscalYear)">(Click here to access the plan section)</small>
        </h5>
        </div>
        <div *ngIf="!refMsgActive">
          <div class="mb-3 col-sm-6 text-secondary information">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Section to review current Fiscal year's Progress
            </span>
          </div>
          <button class="btn btn-goals col-sm-3 curve-edge button-font button-width"
            *ngIf="!isAddNewInitiative && hoshinList.length > 0" (click)="selectKPIsReview()"
            [ngClass]="{ goalsButton: isOverallReviewSelected }">
            KPIs Review
          </button>
          <button class="btn btn-goals col-sm-3 curve-edge button-font button-width"
            *ngIf="!isAddNewInitiative && kpiReviewMissingFields == ''" (click)="selectOverallReview()"
            [ngClass]="{ goalsButton: isKpiReviewSelected }">
            Overall Review
          </button>
          <button class="btn btn-danger col-sm-2 button-font float-right hide-button-print"
            *ngIf="hoshinList.length > 0"
            [disabled]="kpiReviewMissingFields !== ''"
            [title]="kpiReviewMissingFields !== '' ? 'Please complete all initiative evaluations to enable print' : 'Print Reflection'"
            (click)="printReflection()">
            Print
          </button>
          <div class="col-sm-12 mb-2" *ngIf="isKpiReviewSelected && !isOverallReviewSelected">
            <div class="mt-3 text-secondary information" *ngIf="hoshinList.length > 0">
              <span>
                <mat-icon class="info-icon">info</mat-icon>
              </span>
              <span style="padding-top: 2px">Please review the KPIs for each initiative by selecting the
                button in the Action column and completing the required fields for
                every initiative listed in the table below.
              </span>
            </div>
            <div class="card card-style-review mt-3" *ngIf="hoshinList.length > 0">
              <div class="m-4 table-container">
                <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }"
                  class="table table-striped" id="tabledemo">
                  <thead>
                    <tr class="tr-th">
                      <th scope="col" class="text-center" style="width: 50%">ERG Initiative</th>
                      <th class="text-center" scope="col" style="width: 50%" *ngIf="overallStatus === 'APPROVED'">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of hoshinList; let i = index">
                      <td style="width: 50%;"><span>{{ data.bpgInitiative }} : &nbsp;
                          <button *ngIf="data.evaluation == 'Met'" style="margin-left: 0px"
                            class="btn btn-kpi col-sm-4 curve-edge button-font button-width" [ngClass]="{
                          'btn-met': data.evaluation == 'Met',
                          'btn-opc':
                            data.evaluation == 'Partially Met' ||
                            data.evaluation == 'Incomplete'
                        }" (click)="data.evaluation = 'Met'" [disabled]="disabledReflection || isNaacAdmin || isNaacViewOnly">
                            Met
                          </button>
                          <button *ngIf="data.evaluation == 'Partially Met'" style="margin-left: 0px"
                            class="btn btn-kpi col-sm-4 curve-edge button-font button-width" [ngClass]="{
                          'btn-partiallyMet':
                            data.evaluation == 'Partially Met',
                          'btn-opc':
                            data.evaluation == 'Met' ||
                            data.evaluation == 'Incomplete'
                        }" (click)="data.evaluation = 'Partially Met'" [disabled]="disabledReflection || isNaacAdmin || isNaacViewOnly">
                            Partially Met
                          </button>
                          <button *ngIf="data.evaluation == 'Incomplete'" style="margin-left: 0px"
                            class="btn btn-kpi col-sm-4 curve-edge button-font button-width" [ngClass]="{
                          'btn-incomplete': data.evaluation == 'Incomplete',
                          'btn-opc':
                            data.evaluation == 'Partially Met' ||
                            data.evaluation == 'Met'
                        }" (click)="data.evaluation = 'Incomplete'" [disabled]="disabledReflection || isNaacAdmin || isNaacViewOnly">
                            Incomplete
                          </button>
                          <span *ngIf="
                          data.evaluation !== 'Incomplete' &&
                          data.evaluation !== 'Partially Met' &&
                          data.evaluation !== 'Met'
                        ">-</span>
                        </span>
                      </td>
                      <td class="text-center" style="text-decoration: underline; color: #b62027 ;width: 50%; cursor:pointer;"
                        *ngIf="overallStatus === 'APPROVED'">
                        <a (click)="goToKPIEdit(data)" id="goToKpiEdit{{ i }}">
                          <span *ngIf="
                            !data.evaluation &&
                            adminId != '4' &&
                            fiscalYear >= currentFiscalYear
                          ">Complete Evaluation</span>
                          <span *ngIf="
                            data.evaluation &&
                            adminId != '4' &&
                            fiscalYear >= currentFiscalYear
                          ">Update Evaluation</span>
                          <span *ngIf="
                            isNaacAdmin || adminId == '4' || fiscalYear < currentFiscalYear
                          ">View Evaluation</span>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div *ngIf="!disabledReflection" class="col-md-12 mt-5 text-center">
              <div *ngIf="kpiReviewMissingFields != '' && submitButtonClicked" class="color mb-3">
                {{ kpiReviewMissingFields }}
              </div>
              <button *ngIf="adminId != '4' && hoshinList.length > 0" class="btn btn-danger col-sm-2 button-font"
                (click)="updateReview('partialSave')">
                Save
              </button>
              <button *ngIf="adminId != '4' && hoshinList.length > 0" class="btn btn-danger col-sm-2 button-font"
                (click)="checkAllMandatoryDetailsFilledForReview('kpiReview')">
                Save and Proceed
              </button>
              <button *ngIf="adminId == '1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
                data-toggle="modal" data-target="#myModal" (click)="screenExit()" title="Return to Annual Plan Home">
                Cancel
              </button>
            </div>
          </div>
        <div class="col-sm-12" *ngIf="!isKpiReviewSelected && isOverallReviewSelected" class="text-style">
            <div class="mt-3 ml-4 text-secondary information" *ngIf="!highlights">
              <span>
                <mat-icon class="info-icon">info</mat-icon>
              </span>
              <span style="padding-top: 2px">Please outline the key achievements for this fiscal year.</span>
            </div>
            <div style="display: flex" class="mt-4">
              <div class="col-md-3">
                <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Highlights
                  <span class="mandatory-asterisk">*</span>
                </span>
              </div>
              <div class="col-md-9">
                <textarea class="form-control" rows="7" [(ngModel)]="highlights" id="highlights" name="highlights"
                  maxlength="4000" [disabled]="reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly" required readonly="true">
              </textarea>
              </div>
            </div>
            <div class="mt-3 ml-4 text-secondary information" *ngIf="!challenges">
              <span>
                <mat-icon class="info-icon">info</mat-icon>
              </span>
              <span style="padding-top: 2px">Please detail the main challenges encountered during this fiscal
                year.</span>
            </div>
            <div style="display: flex" class="mt-3 mb-2">
              <div class="col-md-3">
                <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Challenges
                  <span class="mandatory-asterisk">*</span></span>
              </div>
              <div class="col-md-9">
                <textarea class="form-control" rows="7" [(ngModel)]="challenges" id="challenges" name="challenges"
                  maxlength="4000" [disabled]="reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly" required readonly="true">
              </textarea>
              </div>
            </div>
            <div style="display: flex" class="mt-3 mb-2">
              <div class="col-md-3">
                <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Additional Comments
                  <span class="mandatory-asterisk">*</span></span>
              </div>
              <div class="col-md-9">
                <textarea class="form-control" rows="7" [(ngModel)]="additionalAdminComments"
                  id="additionalAdminComments" name="additionalAdminComments" maxlength="2000"
                  [disabled]="reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly" required>
              </textarea>
              </div>
            </div>

            <div *ngIf="isOverallReviewSelected && !reflectionChangesDisabled" class="col-md-12 mt-5 text-center">
              <div *ngIf="overallReviewMissingFields != '' && submitButtonClicked" class="color mb-3">
                {{ overallReviewMissingFields }}
              </div>
              <button *ngIf="!isNaacAdmin && adminId != '4'" class="btn btn-danger col-sm-2 button-font"
                (click)="checkAllMandatoryDetailsFilledForReview('overallReview')" title="Submit Overall Review"
                [disabled]="!additionalAdminComments">
                Submit
              </button>
              <button *ngIf="adminId == '1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
                data-toggle="modal" data-target="#myModal" (click)="screenExit()" title="Return to Annual Plan Home">
                Cancel
              </button>
            </div>
          </div>
          <!-- Hidden print container for reflection -->
          <div id="printReflection" style="display: none;">
            <style>
              /* ── Reflection Print — matches hoshin-listing / view-hoshin style ── */
              .rp-body {
                font-family: Montserrat-Light, sans-serif;
                font-size: 13px;
                color: #333;
                padding: 0 60px;
                margin: 0;
              }

              /* Title */
              .rp-title {
                font-size: x-large;
                font-weight: 600;
                font-family: nevis, sans-serif;
                padding: 40px 0 4px;
              }
              .rp-subtitle {
                font-family: Montserrat-Light, sans-serif;
                font-size: 16px;
                color: #555;
                margin-bottom: 20px;
              }

              /* Section headings */
              .rp-section-heading {
                font-size: 16px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                color: #222;
                margin: 32px 0 12px;
                padding-bottom: 6px;
                border-bottom: 2px solid #b62027;
                text-decoration: none;
                font-family: Montserrat-Light, sans-serif;
              }
              .rp-subsection-heading {
                font-size: 12px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                color: #555;
                margin: 14px 0 6px;
                font-family: Montserrat-Light, sans-serif;
              }
              .rp-subheading {
                font-size: 12px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                color: #555;
                margin: 14px 0 6px;
                font-family: Montserrat-Light, sans-serif;
              }

              /* Label / value rows — mirrors .inlineFlex + .space pattern */
              .rp-row {
                display: flex;
                padding: 8px 0 0;
                page-break-inside: avoid;
              }
              .rp-label {
                width: 30%;
                font-family: Montserrat-Light, sans-serif;
                font-weight: bold;
                color: #333;
              }
              .rp-value {
                width: 70%;
                color: #888280;
                white-space: pre-wrap;
                line-height: 1.5;
              }

              /* Tables — mirrors hoshin-listing table style */
              .rp-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 16px;
                font-size: 13px;
                font-family: Montserrat-Light, sans-serif;
                table-layout: fixed;
                word-wrap: break-word;
              }
              .rp-table th {
                border: 1px solid #ccc;
                padding: 8px;
                background: #f5f5f5;
                text-align: left;
                font-weight: bold;
              }
              .rp-table th.center { text-align: center; }
              .rp-table td {
                border: 1px solid #ccc;
                padding: 8px;
                vertical-align: top;
              }
              .rp-table td.center { text-align: center; }

              /* Initiative name in KPI section */
              .rp-initiative-block {
                page-break-inside: avoid;
                border-left: 3px solid #ccc;
                padding: 8px 0 8px 14px;
                margin: 18px 0;
              }
              .rp-initiative-name {
                font-size: 14px;
                font-weight: 700;
                color: #333;
                margin: 0 0 10px;
                padding-bottom: 4px;
                border-bottom: 1px solid #e0e0e0;
                font-family: Montserrat-Light, sans-serif;
              }

              /* Evaluation badges — lightweight, scannable */
              .rp-badge {
                display: inline-block;
                padding: 2px 8px;
                border-radius: 3px;
                font-size: 12px;
                font-weight: bold;
              }
              .rp-badge-met        { background: #d4edda; color: #155724; }
              .rp-badge-partial    { background: #fff3cd; color: #856404; }
              .rp-badge-incomplete { background: #f8d7da; color: #721c24; }
              .rp-badge-none       { color: #888; }

              /* Footer bar — mirrors .amount-style */
              .rp-footer {
                background-color: #f2f2f2;
                margin-top: 32px;
                padding: 12px 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;
                font-family: Montserrat-Light, sans-serif;
                font-size: 12px;
                color: #555;
              }
              .rp-footer-left,
              .rp-footer-right {
                flex: 1 1 0;
                min-width: 0;
                overflow-wrap: break-word;
              }
              .rp-footer-right { text-align: right; }

              @media print {
                @page {
                  margin: 20mm 15mm 18mm 15mm;
                }
                * {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }
                .rp-row              { page-break-inside: avoid; }
                .rp-initiative-block { page-break-inside: avoid; }
                table thead          { display: table-header-group; }
                table tbody tr       { page-break-inside: avoid; }
              }

              /* ── Branding header ── */
              .print-brand-header {
                display: flex;
                align-items: center;
                padding-bottom: 12px;
                border-bottom: 2px solid #cc0000;
                margin-bottom: 20px;
              }
              .print-logo {
                height: 32px;
              }
              .print-meta {
                margin-left: auto;
                text-align: right;
                font-size: 11px;
                color: #555;
                font-family: Montserrat-Light, sans-serif;
              }
              .print-timestamp {
                font-size: 10px;
                color: #888;
              }
            </style>

            <div class="rp-body">

              <!-- Print Header with branding -->
              <div class="print-brand-header">
                <img src="assets/images/ERGconnect_logo.png" alt="ERG Connect" class="print-logo" style="margin-left: 10px;">
                <span class="print-meta">
                  {{ siteName }} {{ bpgName }} | FY{{ fiscalYear }}<br>
                  <small>Printed: {{ printTimestamp }}</small>
                </span>
              </div>

              <!-- Title block -->
              <div class="rp-title">ANNUAL PLAN REFLECTION</div>
              <div class="rp-subtitle">{{ siteName }} {{ bpgName }} &mdash; FY{{ fiscalYear }}</div>
              <hr>

              <!-- Section 1: Reflection Details -->
              <div class="rp-section-heading">Reflection Details</div>

              <div class="rp-subsection-heading">Initiative Evaluations</div>
              <table class="rp-table">
                <thead>
                  <tr>
                    <th style="width: 60%;">ERG Initiative</th>
                    <th style="width: 40%;">Evaluation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of hoshinList">
                    <td>{{ data.bpgInitiative }}</td>
                    <td>
                      <span *ngIf="data.evaluation === 'Met'" class="rp-badge rp-badge-met">Met</span>
                      <span *ngIf="data.evaluation === 'Partially Met'" class="rp-badge rp-badge-partial">Partially Met</span>
                      <span *ngIf="data.evaluation === 'Incomplete'" class="rp-badge rp-badge-incomplete">Incomplete</span>
                      <span *ngIf="!data.evaluation || (data.evaluation !== 'Met' && data.evaluation !== 'Partially Met' && data.evaluation !== 'Incomplete')"
                            class="rp-badge rp-badge-none">&mdash;</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <hr>

              <div class="rp-subsection-heading">KPI Details</div>
              <ng-container *ngFor="let initiative of hoshinList">
                <div *ngIf="initiative.kpiList && initiative.kpiList.length > 0" class="rp-initiative-block">
                  <div class="rp-initiative-name">{{ initiative.bpgInitiative }}</div>
                  <table class="rp-table">
                    <thead>
                      <tr>
                        <th class="center" style="width: 40%;">KPI</th>
                        <th class="center" style="width: 15%;">Planned</th>
                        <th class="center" style="width: 15%;">Achieved</th>
                        <th class="center" style="width: 30%;">Comments</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let kpi of initiative.kpiList">
                        <td>{{ kpi.kpiName }}</td>
                        <td class="center" style="width: 15%;">{{ kpi.kpiCount }}</td>
                        <td class="center" style="width: 15%;">{{ kpi.kpiAchievedCount }}</td>
                        <td>{{ kpi.kpiComments }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- <hr> -->
              </ng-container>

              <hr>

              <!-- Section 2: Overall Review -->
              <div class="rp-section-heading">Overall Review</div>

              <div class="rp-row">
                <div class="rp-label">FY{{ fiscalYear }} Highlights</div>
                <div class="rp-value">{{ highlights }}</div>
              </div>
              <div class="rp-row">
                <div class="rp-label">FY{{ fiscalYear }} Challenges</div>
                <div class="rp-value">{{ challenges }}</div>
              </div>
              <div class="rp-row">
                <div class="rp-label">FY{{ fiscalYear }} Additional Comments</div>
                <div class="rp-value">{{ additionalAdminComments }}</div>
              </div>

              <hr>

              <!-- Footer -->
              <div class="rp-footer">
                <span class="rp-footer-left">{{ siteName }} {{ bpgName }}</span>
                <span class="rp-footer-right">Annual Plan Reflection &mdash; FY{{ fiscalYear }}</span>
              </div>

            </div>
          </div>

          <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
        </div>
      </div>

      <div class="col-md-9 mt-4 pr-0" *ngIf="
          displayType == 'plan' &&
          (adminId == '1' ||
            adminId == '2' ||
            adminId == '3' ||
            isbpgAdmin ||
            isbpgLeadAdmin ||
            ((adminId == '4' || isNaacAdmin) &&
              (overallStatus == 'APPROVED' ||
                overallStatus == 'REJECTED' ||
                overallStatus == 'DRAFT' ||
                overallStatus == 'NEW' ||
                overallStatus == 'SUBMITTED')))
        ">
        <div *ngIf="isGoalsSelected || isInitiativesSelected" class="mb-3 col-sm-6 text-secondary information">
          <span>
            <mat-icon class="info-icon">info</mat-icon>
          </span>
          <span style="padding-top: 2px">Section to Plan for upcoming Fiscal year
          </span>
        </div>
        <button class="btn btn-goals curve-edge button-font button-width-goals"
          *ngIf="!isAddNewInitiative && overallStatus != 'NEW'" (click)="selectInitiative()"
          [ngClass]="{ goalsButton: !isInitiativesSelected }">
          Initiatives
        </button>
        <button class="btn btn-danger col-sm-3 button-font button-width-initiative float-right" *ngIf="
            isInitiativesSelected &&
            !isAddNewInitiativeSelected &&
            !readOnly &&
            !adminsEdit
          " (click)="addNewInitiative()"
          [disabled]="overallStatus === 'APPROVED'">
          Add Initiative
        </button>
        <button class="btn btn-danger col-sm-3 button-font button-width-copy-initiative float-right" *ngIf="
            !isAddNewInitiative &&
            isInitiativesSelected &&
            !readOnly &&
            !adminsEdit &&
            prevInitiativeList.length > 0
          " (click)="copyData('iniative')" [disabled]="cloneDisable">
          Copy FY{{ prevFyShort }} Initiatives
        </button>
        <button class="btn btn-danger col-sm-2 button-font float-right hide-button-print"
          *ngIf="isInitiativesSelected && !isAddNewInitiative && initiativeList.length > 0"
          [disabled]="!isInitiativePrintActive"
          [title]="isInitiativePrintActive ? 'Print Initiatives' : 'Print becomes available after the Annual Plan is submitted'"
          (click)="printInitiatives()">
          Print
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3 ml-2" *ngIf="isAddNewInitiative"
          (click)="detailsClick()" [ngClass]="{ goalsButton: isKpiClicked }">
          Initiative Details
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3"
          *ngIf="isAddNewInitiative && hoshinId > 0" (click)="kpiClick(); onKpiDataChange()" [disabled]="kpiDisable()"
          [ngClass]="{ goalsButton: isDetailsClicked }">
          KPIs
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3"
          [ngClass]="{ goalsButton: !approveOrRejectHoshin }" *ngIf="
            isAddNewInitiative &&
            hoshinId != 0 &&
            overallStatus == 'SUBMITTED' &&
            adminId == '1'
          " (click)="addApproverComments()" style="width: 150px !important" [disabled]="overallStatus === 'APPROVED'">
          Approver Comments
        </button>
        
        <div *ngIf="isInitiativesSelected && !isAddNewInitiative">
          <div class="ml-3 mt-4 mb-3 text-secondary information" *ngIf="overallStatus == 'SUBMITTED' && adminId == '1'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Please review and approve/not approve initiatives using the Approver
              comments section .</span>
          </div>
          <div class="ml-2 mt-4 mb-3 text-secondary information" *ngIf="
              (overallStatus == 'DRAFT' || overallStatus == 'NEW') &&
              prevInitiativeList.length == 0
            ">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Please add Initiatives to submit the Annual Plan . You can do this by
              adding each Initiative individually using the 'Add Initiative'
              button.</span>
          </div>
          <div class="ml-2 mt-4 mb-3 text-secondary information" *ngIf="
              (overallStatus == 'DRAFT' || overallStatus == 'NEW') &&
              prevInitiativeList.length > 0
            ">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">To submit the Annual Plan, please add at least one initiative. You may add initiatives individually using the "Add Initiative" button, or copy initiatives from the previous fiscal year using the "Copy FY{{
              fiscalYearString | slice : -2
              }}
              Initiatives" button.</span>
          </div>
          <div class="card mt-4 card-style-initiative">
            <div class="nodata color-white" *ngIf="initiativeList.length == 0">
              <mat-icon class="notfound" style="color: black !important">assignment</mat-icon>
              <div class="mt-4">No initiatives have been added yet.</div>
            </div>
            <div class="table-container" *ngIf="initiativeList.length > 0">
              <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }" class="table table-striped"
                id="tabledemo">
                <thead>
                  <tr class="tr-th">
                    <th scope="col" style="width: 40%">ERG Initiative</th>
                    <th scope="col" style="width: 17%" *ngIf="
                        overallStatus == 'DRAFT' ||
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'NEW'
                      ">
                      Proposed Budget
                    </th>
                    <th scope="col" style="width: 13%">Frequency</th>
                    <th *ngIf="
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      " scope="col" style="width: 13%">
                      Status
                    </th>
                    <th *ngIf="
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      " scope="col" style="width: 13%">
                      Approved Amount
                    </th>
                    <th class="text-center" *ngIf="!(overallStatus == 'SUBMITTED' && adminId == 1)" scope="col"
                      style="width: 20%">
                      Action
                    </th>
                    <th class="text-center" *ngIf="overallStatus == 'SUBMITTED' && adminId == '1'" scope="col"
                      style="width: 20%">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of initiativeList">
                    <td>
                      {{ data.bpgInitiative
                      }}<span *ngIf="data.isCloned && overallStatus == 'DRAFT'" class="ml-2 color">(cloned)</span>
                      <div *ngIf="data.businessDriversInvalid" class="text-danger" style="font-size: 11px;"
                        title="The selected Annual Plan Driver '{{data.businessDrivers}}' is no longer available for the current fiscal year. Please edit this initiative and select a valid driver.">
                        <i class="fa fa-exclamation-triangle"></i> Action required: Annual Plan Driver no longer valid for this fiscal year.
                      </div>
                    </td>
                    <td *ngIf="
                        overallStatus == 'DRAFT' ||
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'NEW'
                      ">
                      {{ data.proposedBudget | currency : "USD" }}
                    </td>
                    <td>{{ data.frequency }}</td>
                    <td *ngIf="
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      ">
                      <span *ngIf="data.isSuperAdminApproved == true">APPROVED</span>
                      <span *ngIf="data.isSuperAdminApproved == false">NOT APPROVED</span>
                      <span *ngIf="data.isSuperAdminApproved == null">SUBMITTED</span>
                    </td>
                    <td *ngIf="
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      ">
                      {{ data.superAdminApprovedBudget | currency : "USD" }}
                    </td>
                    <td class="text-center" *ngIf="
                        overallStatus == 'DRAFT' ||
                        overallStatus == 'APPROVED' ||
                        (overallStatus == 'REJECTED' && adminId == '1') ||
                        (overallStatus == 'REJECTED' &&
                          !data.isSuperAdminApproved &&
                          adminId != '1') ||
                        overallStatus == 'NEW'
                      ">
                      <a id="editN{{ i }}" class="edit-delete"><img src="assets/images/edit.png" alt="Edit Initiative"
                          class="image" title="Edit Initiative" (click)="editHoshin(data)" style="width: 20px !important" *ngIf="
                            ((overallStatus == 'DRAFT' || overallStatus == 'NEW') && !isNaacViewOnly) ||
                            (overallStatus == 'APPROVED' && adminId == '1') ||
                            (overallStatus == 'REJECTED' && adminId != '4' && !isNaacAdmin)
                          " /></a>
                      <a class="edit-delete ml-2" id="deleteDi{{ i }}"><img src="assets/images/delete.png"
                          alt="Delete Initiative" class="image" title="Delete Initiative" data-toggle="modal" data-target="#myModal"
                          style="width: 20px !important" (click)="deleteHoshin(data.hoshinId)" *ngIf="
                            ((overallStatus == 'DRAFT' || overallStatus == 'NEW') && !isNaacViewOnly) ||
                            (overallStatus == 'REJECTED' && adminId != '4' && !isNaacAdmin)
                          " /></a>
                      <a *ngIf="
                          (overallStatus == 'APPROVED' && adminId != '1') ||
                          (overallStatus == 'REJECTED' && (adminId == '4' || isNaacAdmin)) ||
                          ((overallStatus == 'DRAFT' || overallStatus == 'NEW') && isNaacViewOnly)
                        " class="edit-delete"><img src="assets/images/view.png" alt="View Initiative" class="image"
                          title="View Initiative" id="bsaeHoshin" style="width: 20px !important" (click)="editHoshin(data)" /></a>
                    </td>
                    <td class="text-center" *ngIf="overallStatus == 'SUBMITTED' && adminId == '1'">
                      <a (click)="editHoshin(data, 'approval')" class="color"
                        style="font-size: smaller; cursor: pointer"><b>Review & Approve</b></a>
                    </td>
                    <td class="text-center" *ngIf="
                        (overallStatus == 'SUBMITTED' && adminId != '1') ||
                        (overallStatus == 'REJECTED' &&
                          data.isSuperAdminApproved &&
                          adminId != '1')
                      ">
                      <a class="edit-delete"><img src="assets/images/view.png" class="image" title="View Initiative"
                          alt="View Initiative" id="bsaeHoshin" style="width: 20px !important"
                          (click)="editHoshin(data)" /></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Hidden print container for initiatives -->
          <div id="printInitiatives" style="display: none;">
            <style>
              /* ── Initiative Print — matches hoshin-listing / view-hoshin style ── */
              .ip-body {
                font-family: Montserrat-Light, sans-serif;
                font-size: 13px;
                color: #333;
                padding: 0 60px;
                margin: 0;
              }

              /* Title */
              .ip-title {
                font-size: x-large;
                font-weight: 600;
                font-family: nevis, sans-serif;
                padding: 40px 0 4px;
              }
              .ip-subtitle {
                font-family: Montserrat-Light, sans-serif;
                font-size: 16px;
                color: #555;
                margin-bottom: 20px;
              }

              /* Section headings */
              .ip-section-heading {
                font-size: 16px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                color: #222;
                margin: 32px 0 12px;
                padding-bottom: 6px;
                border-bottom: 2px solid #b62027;
                text-decoration: none;
                font-family: Montserrat-Light, sans-serif;
              }

              /* Initiative block */
              .ip-initiative-block {
                page-break-inside: avoid;
                border-left: 3px solid #ccc;
                padding: 8px 0 8px 14px;
                margin: 18px 0;
              }
              .ip-initiative-name {
                font-size: 14px;
                font-weight: 700;
                color: #333;
                margin: 0 0 10px;
                padding-bottom: 4px;
                border-bottom: 1px solid #e0e0e0;
                font-family: Montserrat-Light, sans-serif;
                break-after: avoid;
              }
              .ip-index {
                color: #b62027;
                font-weight: 700;
                margin-right: 8px;
              }

              /* Long-form narrative fields (WHY / PLAN / HOW / WHERE / WHAT, Action Plan, Approver Comments) */
              .ip-longform {
                margin: 14px 0 4px;
                page-break-inside: avoid;
              }
              .ip-longform-label {
                font-weight: 700;
                color: #333;
                margin-bottom: 4px;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                font-size: 12px;
                font-family: Montserrat-Light, sans-serif;
              }
              .ip-longform-muted {
                font-weight: normal;
                color: #888;
                text-transform: none;
                letter-spacing: 0;
              }
              .ip-longform-value {
                color: #555;
                line-height: 1.5;
                white-space: pre-wrap;
              }
              .ip-subheading {
                font-size: 12px;
                font-weight: 700;
                text-transform: uppercase;
                letter-spacing: 0.4px;
                color: #555;
                margin: 14px 0 6px;
                font-family: Montserrat-Light, sans-serif;
              }

              /* Label / value rows — mirrors .inlineFlex + .space pattern */
              .ip-row {
                display: flex;
                padding: 8px 0 0;
                page-break-inside: avoid;
              }
              .ip-label {
                width: 30%;
                font-family: Montserrat-Light, sans-serif;
                font-weight: bold;
                color: #333;
              }
              .ip-value {
                width: 70%;
                color: #888280;
                white-space: pre-wrap;
                line-height: 1.5;
              }

              /* Tables — mirrors hoshin-listing table style */
              .ip-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 16px;
                font-size: 13px;
                font-family: Montserrat-Light, sans-serif;
                table-layout: fixed;
                word-wrap: break-word;
              }
              .ip-table th {
                border: 1px solid #ccc;
                padding: 8px;
                background: #f5f5f5;
                text-align: left;
                font-weight: bold;
              }
              .ip-table th.center { text-align: center; }
              .ip-table th.right  { text-align: right; }
              .ip-table td {
                border: 1px solid #ccc;
                padding: 8px;
                vertical-align: top;
              }
              .ip-table td.center { text-align: center; }
              .ip-table td.right  { text-align: right; }
              .ip-table .nowrap   { white-space: nowrap; }

              /* Initiative summary column widths */
              .ip-col-init     { width: 30%; }
              .ip-col-driver   { width: 20%; }
              .ip-col-freq     { width: 10%; white-space: nowrap; }
              .ip-col-budget   { width: 14%; }
              .ip-col-status   { width: 14%; white-space: nowrap; }
              .ip-col-approved { width: 12%; }

              /* KPI table column widths */
              .ip-col-kpi      { width: 75%; }
              .ip-col-planned  { width: 25%; }

              /* Evaluation badges */
              .ip-badge {
                display: inline-block;
                padding: 2px 8px;
                border-radius: 3px;
                font-size: 12px;
                font-weight: bold;
              }
              .ip-badge-met        { background: #d4edda; color: #155724; }
              .ip-badge-partial    { background: #fff3cd; color: #856404; }
              .ip-badge-incomplete { background: #f8d7da; color: #721c24; }
              .ip-badge-none       { color: #888; }

              /* Status colours */
              .ip-status-approved  { color: #155724; }
              .ip-status-rejected  { color: #721c24; }
              .ip-status-submitted { color: #555; }

              /* Overall status badge */
              .ip-status-badge {
                font-size: 12px;
                padding: 4px 12px;
                border-radius: 4px;
                float: right;
                font-family: Montserrat-Light, sans-serif;
                font-weight: 600;
                letter-spacing: 0.5px;
              }
              .ip-badge-approved  { background: #e6f4ea; color: #1e7e34; border: 1px solid #1e7e34; }
              .ip-badge-rejected  { background: #fdecea; color: #c62828; border: 1px solid #c62828; }
              .ip-badge-submitted { background: #e8f0fe; color: #1a73e8; border: 1px solid #1a73e8; }
              .ip-badge-draft     { background: #f1f3f4; color: #5f6368; border: 1px solid #5f6368; }

              /* Footer bar — mirrors .amount-style */
              .ip-footer {
                background-color: #f2f2f2;
                margin-top: 32px;
                padding: 12px 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;
                font-family: Montserrat-Light, sans-serif;
                font-size: 12px;
                color: #555;
              }
              .ip-footer-left,
              .ip-footer-right {
                flex: 1 1 0;
                min-width: 0;
                overflow-wrap: break-word;
              }
              .ip-footer-right { text-align: right; }

              @media print {
                @page {
                  margin: 20mm 15mm 18mm 15mm;
                }
                * {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }
                .ip-row              { page-break-inside: avoid; }
                .ip-longform         { page-break-inside: avoid; }
                .ip-initiative-block { page-break-inside: avoid; }
                table thead          { display: table-header-group; }
                table tbody tr       { page-break-inside: avoid; }
              }

              /* ── Branding header ── */
              .print-brand-header {
                display: flex;
                align-items: center;
                padding-bottom: 12px;
                border-bottom: 2px solid #cc0000;
                margin-bottom: 20px;
              }
              .print-logo {
                height: 32px;
              }
              .print-meta {
                margin-left: auto;
                text-align: right;
                font-size: 11px;
                color: #555;
                font-family: Montserrat-Light, sans-serif;
              }
              .print-timestamp {
                font-size: 10px;
                color: #888;
              }
            </style>

            <div class="ip-body">

              <!-- Print Header with branding -->
              <div class="print-brand-header">
                <img src="assets/images/ERGconnect_logo.png" alt="ERG Connect" class="print-logo" style="margin-left: 10px;">
                <span class="print-meta">
                  {{ siteName }} {{ bpgName }} | FY{{ fiscalYear }}<br>
                  <small>Printed: {{ printTimestamp }}</small>
                </span>
              </div>

              <!-- Title block -->
              <div class="ip-title">
                ANNUAL PLAN INITIATIVES
                <span class="ip-status-badge"
                      [ngClass]="{
                        'ip-badge-approved': overallStatus === 'APPROVED',
                        'ip-badge-rejected': overallStatus === 'REJECTED',
                        'ip-badge-submitted': overallStatus === 'SUBMITTED',
                        'ip-badge-draft': overallStatus === 'DRAFT' || overallStatus === 'NEW'
                      }">
                  {{ overallStatus === 'REJECTED' ? 'NOT APPROVED' : overallStatus }}
                </span>
              </div>
              <div class="ip-subtitle">{{ siteName }} {{ bpgName }} &mdash; FY{{ fiscalYear }}</div>

              <!-- Section 1: Reflection Summary (conditional) -->
              <ng-container *ngIf="printInitiativeHoshinList.length > 0">
                <div class="ip-section-heading">Reflection Summary</div>
                <table class="ip-table">
                  <thead>
                    <tr>
                      <th style="width: 65%;">ERG Initiative</th>
                      <th style="width: 35%;">Evaluation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of printInitiativeHoshinList">
                      <td>{{ data.bpgInitiative }}</td>
                      <td>
                        <span *ngIf="data.evaluation === 'Met'" class="ip-badge ip-badge-met">Met</span>
                        <span *ngIf="data.evaluation === 'Partially Met'" class="ip-badge ip-badge-partial">Partially Met</span>
                        <span *ngIf="data.evaluation === 'Incomplete'" class="ip-badge ip-badge-incomplete">Incomplete</span>
                        <span *ngIf="!data.evaluation || (data.evaluation !== 'Met' && data.evaluation !== 'Partially Met' && data.evaluation !== 'Incomplete')"
                              class="ip-badge ip-badge-none">&mdash;</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>

              <!-- Section 2: Initiative Summary -->
              <div class="ip-section-heading">Initiative Summary</div>
              <table class="ip-table">
                <thead>
                  <tr>
                    <th class="ip-col-init">ERG Initiative</th>
                    <th class="ip-col-driver">Annual Plan Drivers</th>
                    <th class="ip-col-freq center">Frequency</th>
                    <th class="ip-col-budget right">Proposed Budget</th>
                    <th class="ip-col-status center" *ngIf="overallStatus === 'SUBMITTED' || overallStatus === 'APPROVED' || overallStatus === 'REJECTED'">Status</th>
                    <th class="ip-col-approved right" *ngIf="overallStatus === 'APPROVED' || overallStatus === 'REJECTED'">Approved Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of initiativeList">
                    <td>{{ data.bpgInitiative }}</td>
                    <td>{{ data.businessDrivers }}</td>
                    <td class="center nowrap">{{ data.frequency }}</td>
                    <td class="right nowrap">{{ data.proposedBudget | currency:'USD' }}</td>
                    <td class="center nowrap" *ngIf="overallStatus === 'SUBMITTED' || overallStatus === 'APPROVED' || overallStatus === 'REJECTED'">
                      <span *ngIf="data.isSuperAdminApproved === true" class="ip-status-approved">APPROVED</span>
                      <span *ngIf="data.isSuperAdminApproved === false" class="ip-status-rejected">NOT&nbsp;APPROVED</span>
                      <span *ngIf="data.isSuperAdminApproved === null" class="ip-status-submitted">SUBMITTED</span>
                    </td>
                    <td *ngIf="overallStatus === 'APPROVED' || overallStatus === 'REJECTED'" class="right nowrap">{{ data.superAdminApprovedBudget | currency:'USD' }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Section 3: Initiative Details -->
              <div class="ip-section-heading">Initiative Details</div>
              <ng-container *ngFor="let initiative of initiativeList; let i = index">
                <div class="ip-initiative-block">
                  <div class="ip-initiative-name">
                    <span class="ip-index">{{ i + 1 }} / {{ initiativeList.length }}</span>
                    {{ initiative.bpgInitiative }}
                  </div>

                  <div class="ip-row">
                    <div class="ip-label">Annual Plan Drivers</div>
                    <div class="ip-value">{{ initiative.businessDrivers || '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Frequency</div>
                    <div class="ip-value">{{ initiative.frequency || '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Proposed Budget</div>
                    <div class="ip-value">{{ initiative.proposedBudget != null ? (initiative.proposedBudget | currency:'USD') : '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Estimated Timing</div>
                    <div class="ip-value">{{ initiative.estimatedTiming ? (initiative.estimatedTiming | date:'MMMM yyyy') : '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Initiative Lead<span *ngIf="fiscalYear > 2026"> 1</span></div>
                    <div class="ip-value">{{ getLeadDisplayName(initiative.leadId1) || '—' }}</div>
                  </div>
                  <div class="ip-row" *ngIf="fiscalYear > 2026">
                    <div class="ip-label">Initiative Lead 2</div>
                    <div class="ip-value">{{ getLeadDisplayName(initiative.leadId2) || '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Additional Funding Requested</div>
                    <div class="ip-value">{{ initiative.isAdditionalFundingSelected ? 'Yes' : 'No' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Additional Funding</div>
                    <div class="ip-value">{{ initiative.additionalFunding != null ? (initiative.additionalFunding | currency:'USD') : '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Additional Funding Source</div>
                    <div class="ip-value">{{ initiative.additionalFundingSource || '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Claimed Amount</div>
                    <div class="ip-value">{{ initiative.claimedAmount != null ? (initiative.claimedAmount | currency:'USD') : '—' }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Add to Calendar</div>
                    <div class="ip-value">{{ initiative.addToCalendar == null ? 'Yes'  : (initiative.addToCalendar ? 'Yes' : 'No') }}</div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Status</div>
                    <div class="ip-value">
                      <span *ngIf="initiative.isSuperAdminApproved === true" class="ip-status-approved">APPROVED</span>
                      <span *ngIf="initiative.isSuperAdminApproved === false" class="ip-status-rejected">NOT APPROVED</span>
                      <span *ngIf="initiative.isSuperAdminApproved === null || initiative.isSuperAdminApproved === undefined">—</span>
                    </div>
                  </div>
                  <div class="ip-row">
                    <div class="ip-label">Approved Amount</div>
                    <div class="ip-value">{{ initiative.superAdminApprovedBudget != null ? (initiative.superAdminApprovedBudget | currency:'USD') : '—' }}</div>
                  </div>
                  <div class="ip-longform" *ngIf="initiative.superAdminApprovalComment">
                    <div class="ip-longform-label">Approver Comments</div>
                    <div class="ip-longform-value">{{ initiative.superAdminApprovalComment }}</div>
                  </div>

                  <!-- Action Plan (FY <= 2026) -->
                  <div *ngIf="fiscalYear <= 2026" class="ip-longform">
                    <div class="ip-longform-label">Action Plan</div>
                    <div class="ip-longform-value">{{ initiative.actionPlan || '—' }}</div>
                  </div>

                  <!-- WHY / PLAN / HOW / WHERE / WHAT (FY > 2026) -->
                  <ng-container *ngIf="fiscalYear > 2026">
                    <div class="ip-longform">
                      <div class="ip-longform-label">WHY <span class="ip-longform-muted">(Reason)</span></div>
                      <div class="ip-longform-value">{{ initiative.why || '—' }}</div>
                    </div>
                    <div class="ip-longform">
                      <div class="ip-longform-label">PLAN <span class="ip-longform-muted">(Activity)</span></div>
                      <div class="ip-longform-value">{{ initiative.plan || '—' }}</div>
                    </div>
                    <div class="ip-longform">
                      <div class="ip-longform-label">HOW <span class="ip-longform-muted">(Method)</span></div>
                      <div class="ip-longform-value">{{ initiative.how || '—' }}</div>
                    </div>
                    <div class="ip-longform">
                      <div class="ip-longform-label">WHERE <span class="ip-longform-muted">(Location)</span></div>
                      <div class="ip-longform-value">{{ initiative.locationWhere || '—' }}</div>
                    </div>
                    <div class="ip-longform">
                      <div class="ip-longform-label">WHAT <span class="ip-longform-muted">(Action)</span></div>
                      <div class="ip-longform-value">{{ initiative.what || '—' }}</div>
                    </div>
                  </ng-container>

                  <!-- KPIs -->
                  <div style="margin-top: 14px;">
                    <div class="ip-subheading">KPIs</div>
                    <ng-container *ngIf="initiative.selectedKpiList && initiative.selectedKpiList.length > 0; else noKpis">
                      <table class="ip-table">
                        <thead>
                          <tr>
                            <th class="ip-col-kpi">KPI</th>
                            <th class="ip-col-planned right">Planned</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let kpi of initiative.selectedKpiList">
                            <td>{{ kpi.kpiName }}</td>
                            <td class="right nowrap">{{ kpi.kpiCount }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </ng-container>
                    <ng-template #noKpis>
                      <div class="ip-value" style="margin-top: 4px;">No KPIs assigned</div>
                    </ng-template>
                  </div>
                </div>
              </ng-container>

              <!-- Footer -->
              <div class="ip-footer">
                <span class="ip-footer-left">{{ siteName }} {{ bpgName }}</span>
                <span class="ip-footer-right">Annual Plan Initiatives &mdash; FY{{ fiscalYear }}</span>
              </div>

            </div>
          </div>

          <p class="errorMessage mt-3 mb-3" *ngIf="errorMsgForMissingKpi != '' && !submitButtonClicked">
            KPIs are required for the following initiatives:
            <span style="color: black">{{ errorMsgForMissingKpi }}</span>
          </p>
          <p class="errorMessage mt-3 mb-3" *ngIf="
              errorMsgForMissingMandatoryFields != '' && !submitButtonClicked
            ">
            Missing Mandatory fields in :
            <span style="color: black">{{
              errorMsgForMissingMandatoryFields
              }}</span>
          </p>
          <div class="color col-md-6 offset-4 mt-4" *ngIf="submitButtonClicked && errorMsg != ''">
            {{ errorMsg }}
          </div>
          <div *ngIf="
              submitButtonClicked &&
              (errorMsgForMissingMandatoryFields != '' ||
                errorMsgForMissingKpi != '')
            " class="color col-md-12 mt-4 mb-3">
            <div class="col-md-12 text-left">
              <div *ngIf="
                  errorMsgForMissingKpi != '' &&
                  errorMsgForMissingMandatoryFields != ''
                ">
                <div class="col-md-12" style="display: inline-flex">
                  <div class="col-md-5">
                    Missing Mandatory fields in Initiatives
                  </div>
                  <span>:</span>
                  <div class="col-md-7">
                    <span style="color: black">{{
                      errorMsgForMissingMandatoryFields
                      }}</span>
                  </div>
                </div>
                <div class="col-md-12" style="display: inline-flex">
                  <div class="col-md-6">Missing KPI's in Initiatives</div>
                  <span>:</span>
                  <div class="col-md-6">
                    <span style="color: black">{{
                      errorMsgForMissingKpi
                      }}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="
                  errorMsgForMissingMandatoryFields != '' &&
                  errorMsgForMissingKpi == ''
                " class="col-md-12" style="display: inline-flex">
                <div class="col-md-5">
                  Missing Mandatory fields in Initiatives
                </div>
                <span>:</span>
                <div class="col-md-7">
                  <span style="color: black">{{
                    errorMsgForMissingMandatoryFields
                    }}</span>
                </div>
              </div>
              <div *ngIf="
                  errorMsgForMissingKpi != '' &&
                  errorMsgForMissingMandatoryFields == ''
                " class="col-md-12" style="display: inline-flex">
                <div class="col-md-6 text-right">
                  Missing KPI's in Initiatives
                </div>
                <span>:</span>
                <div class="col-md-6">
                  <span style="color: black">{{ errorMsgForMissingKpi }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center" *ngIf="
              overallStatus != 'SUBMITTED' &&
              !adminsEdit &&
              overallStatus != 'APPROVED'
            ">
            <button *ngIf="!isNaacViewOnly" id="submitButton" class="btn btn-danger col-sm-2 button-font"
              (click)="submitPlanAndReview()" [disabled]="overallStatus === 'APPROVED'">
              Submit Annual Plan
            </button>
            <button *ngIf="adminId == '1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
              data-toggle="modal" data-target="#myModal" (click)="screenExit()" title="Go to Annual Plan">
              Cancel
            </button>

          </div>
          <div class="col-md-12 pr-0 mt-4 mb-3 text-center">
            <div class="col-md-12" [ngClass]="{
                'amount-style':
                  overallStatus == 'APPROVED' || overallStatus == 'SUBMITTED'
              }" class="mb-3">
              <div class="col-md-6 float-left paddLzero space-style paddL" *ngIf="
                  totalProposedBudget &&
                  (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')
                ">
                <span class="col-md-6 paddLzero font-headding">Requested Amount </span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-3 font-headding">{{
                  totalProposedBudget | currency : "USD"
                  }}</span>
              </div>
              <div class="col-md-6 float-right pr-0 pl-5 paddLzero space-style" *ngIf="
                  overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED'
                ">
                <span class="col-md-6 paddLzero font-headding paddM">Approved Amount</span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-5 font-headding">{{
                  totalApprovedBudget | currency : "USD"
                  }}</span>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <button class="btn btn-danger col-sm-2 button-font" *ngIf="adminId == '1' && overallStatus == 'SUBMITTED'"
              (click)="approveOrReject('APPROVED')" data-toggle="modal" data-target="#myModal"
              [disabled]="!isAllHoshinsApproved">
              Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font"
              *ngIf="adminId == '1' && overallStatus == 'SUBMITTED'" (click)="approveOrReject('REJECTED')"
              data-toggle="modal" data-target="#myModal" [disabled]="!isAnyInitiativeRejected">
              Not Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font"
              *ngIf="adminId == '1' && overallStatus == 'SUBMITTED'" (click)="declineAll()">
              Decline All
            </button>
            <button *ngIf="
                (adminId == '1' || !singleChapterAdmin) &&
                (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')
              " class="btn btn-danger col-sm-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="screenExit()" title="Go to Annual Plan">
              Cancel
            </button>
          </div>
        </div>
        <div *ngIf="
            isAddNewInitiative && isDetailsClicked && !approveOrRejectHoshin
          " class="text-style mt-2">
          <div class="ml-1 mb-3 text-secondary information" *ngIf="
              isSuperAdminApproved == false &&
              !isKpiClicked &&
              isDetailsClicked &&
              overallStatus == 'REJECTED'
            ">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Please review Approver Comments and update the Initiatives
              .</span>
          </div>
          <div class="ml-1 mb-3 text-secondary information" *ngIf="
              overallStatus == 'NEW' ||
              overallStatus == 'DRAFT' ||
              (overallStatus == 'REJECTED' && isSuperAdminApproved == null)
            ">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Please add Initiative details to proceed further.</span>
          </div>
          <form #hoshinForm="ngForm">
            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <span class="col-md-4 label-padding control-label">ERG Initiative<span
                    class="mandatory-asterisk">*</span></span>
                <input type="text" placeholder="Enter initiative" id="bpgInitiative" maxlength="500" autocomplete="off"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="bpgInitiative"
                  name="bpgInitiative" [disabled]="
                    isInitiativeFormDisabled
                  " spellcheck="true" required [title]="bpgInitiative" />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="businessDrivers" class="col-md-4 label-padding control-label">Annual Plan Drivers<span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="businessDrivers" [items]="businessDriversList" placeholder="--Select--" bindLabel="type"
                  bindValue="type" [(ngModel)]="businessDrivers" name="businessDrivers" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " class="col-md-7 form-control form-element input-lg custom outerdiv" (change)="getKpi()"
                  required></ng-select>
              </div>
            </div>

            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="frequency" class="col-md-4 label-padding control-label">Frequency <span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="frequency" [items]="frequencyList" placeholder="--Select--" bindLabel="type"
                  bindValue="type" [(ngModel)]="frequency" name="frequency" required [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
              </div>
              <div class="col-md-6 ml-5 form-row label-padding" *ngIf="frequency == 'Once'">
                <label for="estimatedTime" class="col-md-4 label-padding control-label">Estimated Timing<span
                    class="mandatory-asterisk">*</span></label>
                <input placeholder="Select month/year"
                  class="col-md-7 form-control inputs-padding collapse-control input-lg date-icon" id="estimatedTime"
                  name="estimatedTime{{ bpgInitiative }}" bsDatepicker autocomplete="off"
                  (onShown)="onOpenCalendar($event)" [ngModel]="estimatedTiming" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" (ngModelChange)="onDateChange($event, i)" [disabled]="
                    isInitiativeFormDisabled
                  " [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" [minDate]="minDate" [maxDate]="maxDate" required />
              </div>
            </div>
            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="proposedBudget" type="number" autocomplete="off" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
                  [(ngModel)]="proposedBudget" name="proposedBudget" [readonly]="
                    isInitiativeFormDisabled
                  " onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 "
                  required />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <span class="alignleft form-row daycheck">
                  <span>
                    <mat-checkbox class="mt-1" [ngClass]="{
                      disableEdit: isInitiativeFormDisabled
                    }" [checked]="isAdditionalFundingSelected" [disabled]="
                      isInitiativeFormDisabled
                    " (change)="toggleFundingCheckbox($event)"></mat-checkbox>
                    <span class="bpg-name bold-text ml-3">Additional Funding
                    </span>
                  </span> </span><br />
              </div>

            </div>


            <div *ngIf="isAdditionalFundingSelected" class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="additionalFunding" class="col-md-4 label-padding control-label">Additional
                  Funding ($)</label>
                <input type="number" placeholder="Additional Funding" id="additionalFunding" maxlength="500"
                  autocomplete="off" class="col-md-7 collapse-control form-control input-lg inputs-padding" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [(ngModel)]="additionalFunding" name="additionalFunding" [readonly]="
                    isInitiativeFormDisabled
                  " onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46" />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="additionalFundingSource" class="col-md-4 label-padding control-label">Additional
                  Funding Source</label>
                <input type="text" placeholder="Additional Funding Source" id="additionalFundingSource" maxlength="500"
                  autocomplete="off" class="col-md-7 collapse-control form-control input-lg inputs-padding" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [(ngModel)]="additionalFundingSource" [readonly]="
                    isInitiativeFormDisabled
                  " name="additionalFundingSource" spellcheck="true" />
              </div>
            </div>

            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="leadId1" class="col-md-4 label-padding control-label">Initiative Lead <span *ngIf="fiscalYear > 2026">1</span><span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="leadId1Select" [items]="filteredUserListForLead1" placeholder="--Select--"
                  bindLabel="userFirstName" bindValue="userId" [(ngModel)]="leadId1" name="leadId1" [disabled]="
                    isInitiativeFormDisabled
                  " class="col-md-7 form-control form-element input-lg custom outerdiv" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }">
                </ng-select>
              </div>
              <div class="col-md-6 ml-5 form-row label-padding" *ngIf="fiscalYear > 2026">
                <label for="leadId2" class="col-md-4 label-padding control-label">Initiative Lead 2<span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="leadId2Select" [items]="filteredUserListForLead2" placeholder="--Select--"
                  bindLabel="userFirstName" bindValue="userId" [(ngModel)]="leadId2" name="leadId2" [disabled]="
                    isInitiativeFormDisabled
                  " class="col-md-7 form-control form-element input-lg custom outerdiv" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" >
                </ng-select>
              </div>
            </div>

            <div class="col-md-12 mt-2 pr-0 display-flex">
              <div class="col-md-6 form-row label-padding">
                <span class="alignleft form-row daycheck">
                  <span>
                    <mat-checkbox class="mt-1"
                      [ngClass]="{disableEdit: isInitiativeFormDisabled }"
                      name="addToCalendar" [(ngModel)]="addToCalendar"
                      [disabled]="isInitiativeFormDisabled"></mat-checkbox>
                    <span class="bpg-name bold-text ml-3">Add to Calendar</span>
                  </span>
                </span>
              </div>
            </div>

            <div class="col-md-12 mt-3 pr-0 display-flex"  *ngIf="fiscalYear <= 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="actionPlan" class="col-md-2 textarea-label-padding control-label">Action Plan<span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important" id="actionPlan"
                  [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="actionPlan" maxlength="500" [(ngModel)]="actionPlan" required></textarea>
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex" *ngIf="fiscalYear > 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="why" class="col-md-2 textarea-label-padding control-label">WHY <span style="color:gray">( Reason )</span><span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important"
                  id="why" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="why" maxlength="500" [(ngModel)]="why" (focus)="activeField = 'why'; maxLength = 500;"
                      (blur)="activeField = null;" required></textarea>
                      <small
                      *ngIf="activeField === 'why'"
                      id="whyChar"
                      class="offset-2 col-md-10 form-text text-muted text-center"
                    >
                      {{ getRemainingChars(why,maxLength) }} characters
                      remaining (max {{ maxLength }})
                    </small>
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex" *ngIf="fiscalYear > 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="plan" class="col-md-2 textarea-label-padding control-label">PLAN <span style="color:gray">( Activity )</span><span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important"
                  id="plan" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="plan" maxlength="500" [(ngModel)]="plan" (focus)="activeField = 'plan'; maxLength = 500;"
                      (blur)="activeField = null;" required></textarea>
                      <small
                      *ngIf="activeField === 'plan'"
                      id="planChar"
                      class="offset-2 col-md-10 form-text text-muted text-center"
                    >
                      {{ getRemainingChars(plan,maxLength) }} characters
                      remaining (max {{ maxLength }})
                    </small>
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex" *ngIf="fiscalYear > 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="how" class="col-md-2 textarea-label-padding control-label">HOW <span style="color:gray">( Method )</span><span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important"
                  id="how" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="how" maxlength="500" [(ngModel)]="how" (focus)="activeField = 'how'; maxLength = 500;"
                      (blur)="activeField = null;" required></textarea>
                      <small
                      *ngIf="activeField === 'how'"
                      id="howChar"
                      class="offset-2 col-md-10 form-text text-muted text-center"
                    >
                      {{ getRemainingChars(how,maxLength) }} characters
                      remaining (max {{ maxLength }})
                    </small>
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex" *ngIf="fiscalYear > 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="locationWhere" class="col-md-2 textarea-label-padding control-label">WHERE <span style="color:gray">( Location )</span><span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important"
                  id="locationWhere" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="locationWhere" maxlength="500" [(ngModel)]="locationWhere" (focus)="activeField = 'locationWhere'; maxLength = 500;"
                      (blur)="activeField = null;" required></textarea>
                      <small
                      *ngIf="activeField === 'locationWhere'"
                      id="locationWhereChar"
                      class="offset-2 col-md-10 form-text text-muted text-center"
                    >
                      {{ getRemainingChars(locationWhere,maxLength) }} characters
                      remaining (max {{ maxLength }})
                    </small>
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex" *ngIf="fiscalYear > 2026">
              <div class="col-md-12 form-row label-padding">
                <label for="what" class="col-md-2 textarea-label-padding control-label">WHAT <span style="color:gray">( Action )</span><span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10" rows="6" style="padding-left: 13px !important"
                  id="what" [ngClass]="{
                    disableEdit:
                      isInitiativeFormDisabled
                  }" [disabled]="
                    isInitiativeFormDisabled
                  " name="what" maxlength="500" [(ngModel)]="what" (focus)="activeField = 'what'; maxLength = 500;"
                      (blur)="activeField = null;" required></textarea>
                      <small
                      *ngIf="activeField === 'what'"
                      id="whatChar"
                      class="offset-2 col-md-10 form-text text-muted text-center"
                    >
                      {{ getRemainingChars(what,maxLength) }} characters
                      remaining (max {{ maxLength }})
                    </small>
              </div>
            </div>
            <div *ngIf="
                (overallStatus == 'APPROVED' || overallStatus == 'REJECTED') &&
                isSuperAdminApproved != null
              " class="col-md-12 mt-3 pr-0 mb-4 display-flex">
              <div class="col-md-12 form-row label-padding">
                <span *ngIf="isSuperAdminApproved" class="col-md-2 textarea-label-padding control-label">Approval
                  Comments</span>
                <span *ngIf="!isSuperAdminApproved" class="col-md-2 textarea-label-padding control-label">
                  Comments for Unapproval</span>

                <textarea class="form-control col-md-10" style="padding-left: 13px !important"
                  id="superAdminApprovalComments" [ngClass]="{
                    disableEdit:
                      (overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED') &&
                      adminId != '1'
                  }" [disabled]="
                    (overallStatus == 'APPROVED' ||
                      overallStatus == 'REJECTED') &&
                    adminId != '1'
                  " name="superAdminApprovalComments" maxlength="500"
                  [(ngModel)]="superAdminApprovalComments"></textarea>
              </div>
            </div>
            <div *ngIf="overallStatus == 'APPROVED'" class="col-md-12 mt-2 pr-0 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="proposedBudget" class="col-md-4 label-padding control-label">Approved Amount ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="proposedBudget" type="number" autocomplete="off" [ngClass]="{
                    disableEdit:
                      overallStatus == 'SUBMITTED' ||
                      (overallStatus == 'APPROVED' && adminId != '1') ||
                      (isSuperAdminApproved && adminId != '1')
                  }" class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
                  [(ngModel)]="approvedBudget" name="approvedBudget" [readonly]="
                    (overallStatus == 'APPROVED' && adminId != '1') ||
                    (isSuperAdminApproved && adminId != '1')
                  " onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 "
                  required />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="claimedAmount" class="col-md-4 label-padding control-label">Claimed Amount ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="claimedAmount" type="number" autocomplete="off"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="claimedAmount"
                  name="claimedAmount" [readonly]="true" [ngClass]="{ disableEdit: true }"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 " />
              </div>
            </div>
          </form>
          <div class="mt-4 mb-4 text-center">
            <button *ngIf="
                (overallStatus == 'NEW' ||
                  overallStatus == 'DRAFT' ||
                  (overallStatus == 'REJECTED' &&
                    !isSuperAdminApproved &&
                    adminId != '1') ||
                  (overallStatus == 'REJECTED' && adminId == '1') ||
                  (overallStatus == 'APPROVED' && adminId == '1')) &&
                !isNaacViewOnly
              " class="btn btn-danger col-sm-2 col-md-2 button-font" [disabled]="!hoshinForm.valid || overallStatus === 'APPROVED'"
              (click)="createBudgetId()"> 
              <!-- replaced savehoshin() with createBudgetId() -->
              Save and Proceed
            </button>
            <button *ngIf="
                (overallStatus == 'NEW' ||
                  overallStatus == 'DRAFT' ||
                  (overallStatus == 'REJECTED' &&
                    !isSuperAdminApproved &&
                    adminId != '1') ||
                  (overallStatus == 'REJECTED' && adminId == '1') ||
                  (overallStatus == 'APPROVED' && adminId == '1')) &&
                !isNaacViewOnly
              " class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi('cancelKpi')">
              Cancel
            </button>
            <button *ngIf="
                overallStatus == 'SUBMITTED' ||
                (overallStatus == 'REJECTED' &&
                  isSuperAdminApproved &&
                  adminId != '1') ||
                (overallStatus == 'APPROVED' && adminId != '1') ||
                isNaacViewOnly ||
                isNaacAdmin
              " class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Back To Initiatives
            </button>
          </div>
          <div></div>
        </div>
        <div *ngIf="
            isKpiClicked &&
            !approveOrRejectHoshin &&
            (overallStatus == 'NEW' ||
              overallStatus == 'DRAFT' ||
              (overallStatus == 'REJECTED' &&
                isSuperAdminApproved == false &&
                adminId != '4') ||
              (overallStatus == 'REJECTED' && isSuperAdminApproved == null))
          " class="ml-2 mb-3 text-secondary">
          <div class="information">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Please add Performance Indicators (KPIs) . You need to
              mandatorily choose one KPI from the existing options in the
              dropdown menu and include metrics. You can create a new KPI by
              using the 'Click here to add custom KPI' link.</span>
          </div>
          <br />
          <div class="information">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Step 1: Please select KPI from dropdown or add custom KPI.</span>
          </div>
        </div>
        <div class="nodata color-white" *ngIf="
            (kpiList == null || kpiList.length == 0) &&
            isKpiClicked &&
            !approveOrRejectHoshin
          ">
          <mat-icon class="notfound" style="color: black !important">assignment</mat-icon>
          <div class="mt-4">No KPIs added</div>
        </div>
        <div *ngIf="
            isAddNewInitiative &&
            isKpiClicked &&
            kpiList != null && kpiList.length != 0 &&
            !approveOrRejectHoshin
          " class="text-style">
          <div class="col-md-12 pl-0">
            <div *ngIf="
                !isSuperAdminApproved &&
                overallStatus != 'APPROVED' &&
                (((overallStatus == 'NEW' || overallStatus == 'DRAFT') && !isNaacViewOnly) ||
                  adminsEdit ||
                  (overallStatus == 'REJECTED' &&
                    !isSuperAdminApproved &&
                    adminId != '1' &&
                    adminId != '4') ||
                  (overallStatus == 'REJECTED' && adminId == '1'))
              " class="col-md-12 form-row align label-padding" style="margin-left: 15px">
              <label for="kpi" class="col-md-1 label-padding control-label">KPI</label>
              <ng-select id="selectKpi" [items]="kpiList" placeholder="--Select KPI--" bindLabel="kpiName" name="kpi"
                bindValue="kpiId" [(ngModel)]="kpi" (change)="manageKpi($event)" style="font-size: 13px"
                class="col-md-11 form-control form-element input-lg custom outerdiv">
              </ng-select>
            </div>
            <div *ngIf="
                !isSuperAdminApproved &&
                overallStatus != 'APPROVED' &&
                (((overallStatus == 'NEW' || overallStatus == 'DRAFT') && !isNaacViewOnly) ||
                  adminsEdit ||
                  (overallStatus == 'REJECTED' &&
                    !isSuperAdminApproved &&
                    adminId != '1' &&
                    adminId != '4') ||
                  (overallStatus == 'REJECTED' && adminId == '1'))
              " class="col-md-12 form-row align label-padding">
              <span class="col-md-1"></span>
              <a class="anchor text-medium-style color cursor-pointer mb-3 col-md-11 pl-4" style="margin-left: 0"
                (click)="manageCustomKpi()">Click here to add custom kpi</a>
            </div>
          </div>
          <div class="ml-2 mb-3 text-secondary information" *ngIf="addCustomKpi && overallStatus != 'APPROVED'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px">Step 2: Please add the count and click on add button .</span>
          </div>
          <div class="col-md-12 pr-0 display-flex" *ngIf="addCustomKpi && overallStatus != 'APPROVED'">
            <div class="col-md-10 form-row align label-padding">
              <label for="kpiName" class="col-md-1 label-padding pl-2 control-label remove-title-margin"
                style="margin-right: 7px">
                KPI</label>
              <input type="text" placeholder="Enter KPI" style="font-size: 13px" id="kpiName" maxlength="500"
                autocomplete="off" class="col-md-10 ml-2 pl-2 collapse-control form-control input-lg inputs-padding"
                [(ngModel)]="kpiName" name="kpiName" [readonly]="kpiNameEditable" spellcheck="true" />
            </div>
            <div class="col-md-1 form-row align label-padding" style="width: 15%">
              <input type="number" placeholder="Count" style="font-size: 13px" id="kpiCount" maxlength="500"
                autocomplete="off" class="col-md-12 pl-2 collapse-control form-control input-lg" [(ngModel)]="kpiCount"
                name="kpiCount"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46" />
            </div>
            <button *ngIf="!isEditKpi" class="col-md-1 btn btn-danger curve-edge button-font mt-2" style="width: 7%"
              (click)="addNewKpi('add')" [disabled]="
                kpiName == null ||
                kpiName == undefined ||
                kpiName == '' ||
                kpiCount == null ||
                kpiCount == undefined ||
                kpiCount == ''
              ">
              Add
            </button>
            <button *ngIf="isEditKpi" class="btn btn-danger curve-edge button-font mt-2" (click)="addNewKpi('update')"
              [disabled]="
                kpiName == null ||
                kpiName == undefined ||
                kpiName == '' ||
                kpiCount == null ||
                kpiCount == undefined ||
                kpiCount == ''
              ">
              Update
            </button>
          </div>

          <div class="ml-3 color-white card card-style-kpi" *ngIf="selectedKpiList.length > 0 && isKpiClicked">
            <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }"
              class="mt-4 table table-striped" id="tabledemo">
              <thead>
                <tr class="tr-th">
                  <th scope="col" class="text-center" style="width: 40%">
                    KPI
                  </th>
                  <th scope="col" class="text-center" style="width: 12%">
                    Planned
                  </th>
                  <th scope="col" class="text-center" style="width: 12%; white-space: nowrap"
                    *ngIf="isSuperAdminApproved">
                    <span class="font-weight-bold col-md-4"> Achieved
                      <span class="mandatory-asterisk">*</span></span>

                  </th>
                  <th scope="col" class="text-center" style="width: 36%" *ngIf="isSuperAdminApproved">
                    <span class="font-weight-bold col-md-4"> KPI Comments
                      <span class="mandatory-asterisk">*</span></span>
                  </th>
                  <th class="text-center" *ngIf="
                      !isSuperAdminApproved &&
                      overallStatus != 'APPROVED' &&
                      (overallStatus == 'NEW' ||
                        overallStatus == 'DRAFT' ||
                        adminsEdit ||
                        (overallStatus == 'REJECTED' &&
                          !isSuperAdminApproved &&
                          adminId != '1' &&
                          adminId != '4') ||
                        (overallStatus == 'REJECTED' && adminId == '1'))
                    " scope="col" style="width: 10%">
                    Update
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of selectedKpiList; let i = index">
                  <td>{{ data.kpiName }}</td>
                  <td class="text-center">
                    <input type="number" style="font-size: 13px" id="kpiCount" maxlength="500" autocomplete="off"
                      class="col-md-12 pl-2 collapse-control form-control" style="
                        background-color: lightgray;
                        text-align: center;
                        height: 32px;
                      " [(ngModel)]="data.kpiCount" name="kpiCount" [readonly]="true" />
                  </td>
                  <td class="text-center" *ngIf="isSuperAdminApproved">
                    <input type="number" style="font-size: 13px" id="kpiAchievedCount" maxlength="500"
                      autocomplete="off" class="col-md-12 pl-2 collapse-control form-control" style="
                        background-color: white;
                        border-color: #b62027;
                        text-align: center;
                        height: 32px;
                      " [(ngModel)]="data.kpiAchievedCount" name="kpiAchievedCount" (focus)="onKpiDataChange()"
                      (blur)="onKpiDataChange()" [readonly]="reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly"
                      [disabled]="isNaacAdmin || isNaacViewOnly" />
                  </td>
                  <td class="text-center" *ngIf="isSuperAdminApproved">
                    <input type="text" style="font-size: 13px" id="kpiComments" maxlength="2000" autocomplete="off"
                      class="col-md-12 pl-2 collapse-control form-control" style="
                        background-color: white;
                        border-color: #b62027;
                        height: 32px;
                      " [(ngModel)]="data.kpiComments" name="kpiComments"
                      [readonly]="reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly" [disabled]="isNaacAdmin || isNaacViewOnly"
                      [title]="data.kpiComments" (focus)="activeCommentIndex = i; onKpiDataChange()"
                      (blur)="activeCommentIndex = null; onKpiDataChange()" />
                    <small *ngIf="activeCommentIndex === i" id="{{ 'comments-kpi-' + i }}" class="form-text text-muted">
                      {{ getRemainingChars(data.kpiComments) }} characters
                      remaining (max {{ maxLength }})
                    </small>
                  </td>
                  <td class="text-center" *ngIf="
                      !isSuperAdminApproved &&
                      overallStatus != 'APPROVED' &&
                      (overallStatus == 'NEW' ||
                        overallStatus == 'DRAFT' ||
                        adminsEdit ||
                        (overallStatus == 'REJECTED' &&
                          !isSuperAdminApproved &&
                          adminId != '1' &&
                          adminId != '4' &&
                          !isNaacAdmin) ||
                        (overallStatus == 'REJECTED' && adminId == '1'))
                    ">
                    <a id="editN{{ i }}" class="edit-delete"><img src="assets/images/edit.png" class="image"
                        alt="Angular Logo" title="Edit" (click)="editKpi(data)" /></a>
                    <a class="edit-delete ml-2" id="deleteDi{{ i }}"><img src="assets/images/delete.png" class="image"
                        alt="Angular Logo" title="Delete" (click)="deleteKpi(data)" /></a>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <section class="mt-2" name="kpiReflection" *ngIf="isSuperAdminApproved">
              <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }"
                class="table table-borderless" id="tablekpieval">
                <tbody>
                  <ng-container *ngFor="let data of initiativeList; let i = index">
                    <ng-container *ngIf="data.hoshinId === hoshinId">
                      <!-- Evaluation row -->
                      <tr>
                        <td class="text-center" style="width: 40%;" scope="row">
                          <span class="font-weight-bold col-md-4"> Overall Initiative Evaluation
                            <span class="mandatory-asterisk">*</span></span>
                        </td>
                        <td style="width: 60%">
                          <div role="group" aria-label="Overall evaluation">
                            <button type="button" class="btn btn-kpi col-sm-2 curve-edge button-font button-width"
                              style="margin-left: 0px; font-weight: 100" [ngClass]="{
                                'btn-met':
                                  !data.evaluation || data.evaluation === 'Met',
                                'btn-opc':
                                  !!data.evaluation && data.evaluation !== 'Met'
                              }" (click)="data.evaluation = 'Met';onKpiDataChange()" [disabled]="
                                reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly
                              " [attr.aria-pressed]="data.evaluation === 'Met'">
                              Met
                            </button>

                            <button type="button" class="btn btn-kpi col-sm-4 curve-edge button-font button-width"
                              style="font-weight: 100" [ngClass]="{
                                'btn-partiallyMet':
                                  !data.evaluation ||
                                  data.evaluation === 'Partially Met',
                                'btn-opc':
                                  !!data.evaluation &&
                                  data.evaluation !== 'Partially Met'
                              }" (click)="data.evaluation = 'Partially Met';onKpiDataChange()" [disabled]="
                                reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly
                              " [attr.aria-pressed]="
                                data.evaluation === 'Partially Met'
                              ">
                              Partially Met
                            </button>

                            <button type="button" class="btn btn-kpi col-sm-3 curve-edge button-font button-width"
                              style="font-weight: 100" [ngClass]="{
                                'btn-incomplete':
                                  !data.evaluation ||
                                  data.evaluation === 'Incomplete',
                                'btn-opc':
                                  !!data.evaluation &&
                                  data.evaluation !== 'Incomplete'
                              }" (click)="data.evaluation = 'Incomplete';onKpiDataChange()" [disabled]="
                                reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly
                              " [attr.aria-pressed]="
                                data.evaluation === 'Incomplete'
                              ">
                              Incomplete
                            </button>
                          </div>
                        </td>
                      </tr>

                      <!-- Highlights row -->
                      <tr>
                        <td class="text-center" style="width: 40%;" scope="row">
                          <label [attr.for]="'highlights-' + i">
                            <span class="font-weight-bold col-md-4"> Overall Initiative Highlights
                              <span class="mandatory-asterisk">*</span></span>
                          </label>
                        </td>
                        <td class="text-center" style="width: 60%">
                          <textarea class="form-control" style="
                              background-color: white;
                              border-color: #b62027;
                            " id="{{ 'highlights-' + i }}" [(ngModel)]="data.highlights" [disabled]="isNaacAdmin || isNaacViewOnly"
                            rows="3" maxlength="{{ maxLength }}" [attr.aria-describedby]="'highlights-help-' + i"
                            (ngModelChange)="data.highlights = $event" (focus)="
                              activeHighlights = 'highlights'; onKpiDataChange()
                            " (blur)="activeHighlights = null; onKpiDataChange()" [readonly]="
                              reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly
                            ">
                          </textarea>
                          <small *ngIf="activeHighlights === 'highlights'" id="{{ 'highlights-kpi-' + i }}"
                            class="form-text text-muted">
                            {{ getRemainingChars(data.highlights) }} characters
                            remaining (max {{ maxLength }})
                          </small>
                        </td>
                      </tr>

                      <!-- Challenges row -->
                      <tr>
                        <td class="text-center" style="width: 40%;" scope="row">
                          <label [attr.for]="'challenges-' + i">
                            <span class="font-weight-bold col-md-4"> Overall Initiative Challenges
                              <span class="mandatory-asterisk">*</span></span>
                          </label>
                        </td>
                        <td class="text-center" style="width: 60%">
                          <textarea class="form-control" style="
                              background-color: white;
                              border-color: #b62027;
                            " id="{{ 'challenges-' + i }}" [(ngModel)]="data.challenges" [disabled]="isNaacAdmin || isNaacViewOnly"
                            rows="3" maxlength="{{ maxLength }}" [attr.aria-describedby]="'challenges-help-' + i"
                            (ngModelChange)="data.challenges = $event" (focus)="
                              activeChallenges = 'challenges'; onKpiDataChange()
                            " (blur)="activeChallenges = null; onKpiDataChange()" [readonly]="
                              reflectionChangesDisabled || isNaacAdmin || isNaacViewOnly
                            ">
                          </textarea>
                          <small *ngIf="activeChallenges === 'challenges'" id="{{ 'challenges-kpi-' + i }}"
                            class="form-text text-muted">
                            {{ getRemainingChars(data.challenges) }} characters
                            remaining (max {{ maxLength }})
                          </small>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </section>
          </div>
          <div class="nodata color-white" *ngIf="selectedKpiList.length == 0">
            <mat-icon class="notfound" style="color: black !important">assignment</mat-icon>
            <div class="mt-4">No KPIs added</div>
          </div>
          <div *ngIf="(!readOnly || isSuperAdminApproved) || isNaacViewOnly" class="col-md-12 mt-5 mb-4 text-center">
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="saveKpi()"
              [disabled]="((!enableSaveInitiativeButton) && isSuperAdminApproved) || selectedKpiList.length == 0"               *ngIf="
                !isNaacViewOnly &&
                ((isSuperAdminApproved && !reflectionChangesDisabled) ||
                (overallStatus == 'NEW' || overallStatus == 'DRAFT') ||
                (overallStatus == 'REJECTED' &&
                  !isSuperAdminApproved &&
                  adminId != '1' &&
                  adminId != '4' &&
                  !isNaacAdmin) ||
                (overallStatus == 'REJECTED' && adminId == '1'))
              ">
              Save Initiative
            </button>
            <button *ngIf="
                !isNaacViewOnly &&
                (overallStatus == 'NEW' ||
                  overallStatus == 'DRAFT' ||
                  (overallStatus == 'REJECTED' &&
                    !isSuperAdminApproved &&
                    adminId != '1') ||
                  (overallStatus == 'REJECTED' && adminId == '1') ||
                  (overallStatus == 'APPROVED' && adminId == '1'))
              " class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi('cancelKpi')">
              Cancel
            </button>
            <button *ngIf="
                overallStatus == 'SUBMITTED' ||
                isNaacViewOnly ||
                (overallStatus == 'APPROVED' && adminId != '1')
              " class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Back To Initiatives
            </button>
          </div>
          <div *ngIf="
              !enableSaveInitiativeButton &&
              !isNaacAdmin &&
              adminId != '4' &&
              fiscalYear >= currentFiscalYear && isSuperAdminApproved
            " class="text-center">
            <span style="color: #b62027">***{{ kpiReviewMissingFields }}***</span>
          </div>
        </div>
        <div class="ml-4 mt-2" *ngIf="approveOrRejectHoshin">
          <span class="alignleft daycheck">
            <span>
              <mat-checkbox name="hoshinApproveClicked" [checked]="hoshinApproveClicked"
                (change)="toggleCheckbox($event)"></mat-checkbox>
              <span class="bpg-name bold-text ml-2">Click here to approve the Annual Plan Initiative
              </span>
            </span> </span><br /><br />
          <div class="col-md-12 form-row label-padding ml-2">
            <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget ($)</label>

            <input id="proposedBudget" type="number" autocomplete="off" [ngClass]="{ disableEdit: true }"
              class="col-md-3 collapse-control form-control input-lg inputs-padding" [disabled]="true"
              [(ngModel)]="proposedBudget" name="proposedBudget" />
          </div>
          <div class="col-md-12 form-row label-padding ml-2" *ngIf="hoshinApproveClicked">
            <label for="approvedAmount" class="col-md-4 label-padding control-label">Approval Amount ($)<span
                class="mandatory-asterisk">*</span></label>

            <input id="approvedAmount" type="number" autocomplete="off"
              class="col-md-3 collapse-control form-control input-lg inputs-padding" placeholder="Enter amount"
              [(ngModel)]="approvedAmount" name="approvedAmount"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 " required />
          </div>
          <div class="col-md-12 form-row label-padding">
            <span class="col-md-4 label-padding control-label" style="margin-left: 10px">Approved/Not Approved Comment<span
                class="mandatory-asterisk">*</span></span>
            <textarea placeholder="Enter Comments" style="padding-left: 13px !important; font-size: 0.8rem"
              class="form-control col-md-5" id="approveRejectComment" name="approveRejectComment" maxlength="500"
              [(ngModel)]="approveRejectComment" required></textarea>
          </div>
          <div class="mt-5 mb-4 text-center">
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="submitApproval('approve')" [disabled]="
                !hoshinApproveClicked ||
                approvedAmount == null ||
                approvedAmount == undefined ||
                approveRejectComment == null ||
                approveRejectComment == undefined ||
                approveRejectComment == ''
              ">
              Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="submitApproval('reject')" [disabled]="
                hoshinApproveClicked ||
                approveRejectComment == '' ||
                approveRejectComment == null ||
                approveRejectComment == undefined
              ">
              Not Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Cancel
            </button>
          </div>
        </div>

        <!-- Decline All Overlay -->
        <div class="decline-all-overlay" *ngIf="showDeclineAllModal" (click)="cancelDeclineAll()">
          <div class="decline-all-popup" (click)="$event.stopPropagation()">
            <div class="decline-all-header">
              <h3>Decline All Initiatives</h3>
              <button class="decline-all-close" (click)="cancelDeclineAll()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div class="decline-all-body">
              <div class="decline-all-warning">
                <mat-icon>info_outline</mat-icon>
                <span>This will decline all submitted <strong>initiatives</strong>.</span>
              </div>
              <div class="decline-all-form">
                <label class="decline-all-label" for="rejectAllComment">
                  Comments <span class="mandatory-asterisk">*</span>
                </label>
                <textarea class="decline-all-textarea" id="rejectAllComment" name="rejectAllComment"
                  placeholder="Provide comments so submitters understand what needs to change..."
                  maxlength="500" rows="4"
                  [(ngModel)]="declineAllComment"></textarea>
                <div class="decline-all-char-count" [ngClass]="{ 'near-limit': declineAllComment.length > 400 }">
                  {{ declineAllComment.length }} / 500
                </div>
              </div>
            </div>
            <div class="decline-all-footer">
              <button type="button" class="decline-all-btn-cancel" (click)="cancelDeclineAll()">Cancel</button>
              <button type="button" class="decline-all-btn-confirm" (click)="confirmDeclineAll()"
                [disabled]="!declineAllComment || declineAllComment.trim() === ''">
                Decline All
              </button>
            </div>
          </div>
        </div>

        <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
      </div>

      <div *ngIf="isViewClicked" class="modal fade" id="bpgBaseModal" data-backdrop="true" tabindex="-1"
        style="background-color: rgba(0, 0, 0, 0.5)">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content font-color modal-top">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">ERG Initiative</h4>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.bpgInitiative">
                <span class="col-md-4 paddLzero">ERG Initiative </span>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.bpgInitiative
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.businessDrivers">
                <label for="businessDrivers" class="col-md-4 paddLzero">Business Drivers</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.businessDrivers
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.proposedBudget">
                <label for="proposedBudget" class="col-md-4 paddLzero">Proposed Budget</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.proposedBudget | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.frequency">
                <label for="actionPlan" class="col-md-4 paddLzero">Frequency</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.frequency
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="
                  hoshinBase.frequency == 'Monthly' ||
                  hoshinBase.frequency == 'Quarterly'
                ">
                <label for="estimatedTiming" class="col-md-4 paddLzero">Estimated Timing</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.estimatedTiming
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.lead1Name == null">
                <label for="businessDrivers" class="col-md-4 paddLzero">Initiative Lead</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.lead1Name
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.actionPlan == ''">
                <label for="actionPlan" class="col-md-4 paddLzero">Action Plan</label>
                <span class="col-md-7 desc-color" [innerHtml]="hoshinBase.actionPlan">
                </span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFunding == null">
                <label for="superAdminApprovalComment" class="col-md-4 paddLzero">Additional Funding</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.additionalFunding | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFundingSource == null">
                <label for="superAdminApprovalComment"
                  class="col-md-4 paddLzero additional-funding-text-align">Additional Funding Source</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.additionalFundingSource
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.superAdminApprovedBudget">
                <label for="superAdminApprovedBudget" class="col-md-4 paddLzero">Approval Amount</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.superAdminApprovedBudget | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.superAdminApprovalComment">
                <label for="superAdminApprovalComment" class="col-md-4 paddLzero">Approval Comment</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.superAdminApprovalComment
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.kpi">
                <label for="kpi" class="col-md-4 paddLzero">KPI</label>
                <span class="col-md-7 desc-color">
                  <p [innerHtml]="hoshinBase.kpi"></p>
                </span>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-danger" data-dismiss="modal"
                (click)="isViewClicked = false">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
